var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-4"},[_c('vendor-comp-item-list',{attrs:{"vendorId":_vm.resource.id,"enabled-columns":['title', 'comp_item', 'valid_to', 'overall_status', 'files']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }